import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-marketpalce',
  templateUrl: './marketpalce.component.html',
  styleUrls: ['./marketpalce.component.css']
})
export class MarketpalceComponent implements OnInit {

  authToken = localStorage.getItem('auth');

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}` }),
    withCredentials: true,
  };

  businessID = this.route.snapshot.params.businessID;
  openings = [];
  //If companyID exists then we have own company
  companyID = this.route.snapshot.params.id;

  constructor( 
    private fb: FormBuilder,
    private router: Router,
    private http: HttpClient,
    private route:ActivatedRoute,
    private authService: AuthService) { }


    ngOnInit(): void {
      if(this.companyID){
        this.fetchMinifiedMarketplace();
      }
      else{
        this.fetchOthersMarketplace();
      }
      
    }
  
    fetchMinifiedMarketplace() {
      this.http.get(environment.OWN_MARKET_PLACE, this.httpOptions).subscribe(
        (res: any) => {
          if(res.status == 200 ) {
            this.openings = res.message;
            console.log(this.openings)
          }
          else {
            this.openings = []
          }
          
        }, (err: any) => {
  
        }
      )
    }

    fetchOthersMarketplace() {
      this.http.get(environment.OTHERS_MARKET_PLACE, this.httpOptions).subscribe(
        (res: any) => {
          if(res.status == 200 ) {
            this.openings = res.message;
            console.log(this.openings)
          }
          else {
            this.openings = []
          }
          
        }, (err: any) => {
  
        }
      )
    }

}
